export const IMPORT_TYPES = {
  import_products_from_iai: 'Produkty - IAI',
  import_products_from_subiekt: 'Produkty - Subiekt',
  import_orders_from_iai: 'Zamówienia - IAI',
  undefined: '---'
}
